// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_1ff71798 rdg_c29ca9ed rdg_cc46a4c3","iconAndName":"rdg_ef75043b"};